module.exports = __webpack_public_path__ + "static/media/facebook.ca89501c.svg";